import { useContext } from "react";
import { AuthActions, AuthState } from "./types";
import { AuthContext } from "data/auth/AuthProvider";

export const useAuth = (): [AuthState, AuthActions] => {
  const context = useContext(AuthContext);

  return [context.auth, context.actions];
};
